import { events as createPointerEvents } from '@react-three/fiber';
import type { EventManager, RootStore } from '@react-three/fiber';

/**
 * R3F's default event manager crashes if `connect` runs with a null target
 * (async Canvas configure finishing after the host unmounts). Skip connect then.
 */
export function createSafeCanvasEvents(store: RootStore): EventManager<HTMLElement> {
  const manager = createPointerEvents(store);
  const baseConnect = manager.connect?.bind(manager);
  manager.connect = (target: HTMLElement) => {
    if (target == null) return;
    baseConnect?.(target);
  };
  return manager;
}
